if (!customElements.get('boost-buttons')) {
  customElements.define(
    'boost-buttons',
    class BoostButtons extends window.BAO.CustomElement {
      CLASSES = {
        sortDropdown: 'boost-pfs-filter-filter-dropdown',
        activeFilterButton: 'clc-Header_NavigationLink-active',
      }

      BOOST_ELEMENTS = {
        sortByWrapper: '.boost-pfs-filter-top-sorting',
        refineByValue: '.refine-by-value',
        filterButton: '.boost-pfs-filter-button',
        filterButtonValue: '.boost-pfs-filter-option-value',
        clearAllButton: '.boost-pfs-filter-clear-all',
      }

      constructor () {
        super()

        this.clickBoostButton = this.clickBoostButton.bind(this)

        if (this.els?.button?.exists) {
          this.els.button.elements.forEach(buttonEl => {
            this.listeners.add(buttonEl, 'click', this.clickBoostButton)
          })
        }

        this.clickClearButton = this.clickClearButton.bind(this)

        if (this.els?.clear?.exists) {
          this.els.clear.elements.forEach(clearEl => {
            this.listeners.add(clearEl, 'click', this.clickClearButton)
          })
        }

        this.detectBoostUpdates()
      }

      clickClearButton () {
        document
          .querySelectorAll(this.BOOST_ELEMENTS.clearAllButton)
          .forEach(clearAllButton => {
            clearAllButton.click()
          })
      }

      clickBoostButton (e) {
        const clickedLabel = e.currentTarget.dataset.label

        document
          .querySelectorAll(this.BOOST_ELEMENTS.filterButton)
          .forEach(filterButton => {
            const filterButtonValue = filterButton.querySelector(
              this.BOOST_ELEMENTS.filterButtonValue,
            )

            if (filterButtonValue === null) return

            if (filterButtonValue.innerHTML === clickedLabel) { filterButton.click() }
          })
      }

      updateButtonState () {
        if (this.els?.button?.exists) {
          this.els.button.elements.forEach(buttonEl => {
            buttonEl.classList.remove(this.CLASSES.activeFilterButton)
          })
        }

        if (this.els?.clear?.exists) {
          this.els.clear.elements.forEach(clearEl => {
            clearEl.classList.remove(this.CLASSES.activeFilterButton)
          })
        }

        if (
          document.querySelectorAll(this.BOOST_ELEMENTS.refineByValue)
            .length === 0
        ) {
          if (this.els?.clear?.exists) {
            this.els.clear.elements.forEach(clearEl => {
              clearEl.classList.add(this.CLASSES.activeFilterButton)
            })
          }
        }

        document
          .querySelectorAll(this.BOOST_ELEMENTS.refineByValue)
          .forEach(activeFilter => {
            const activeFilterValue = activeFilter.innerHTML

            if (activeFilterValue === null) return

            if (this.els?.button?.exists) {
              this.els.button.elements.forEach(buttonEl => {
                if (activeFilterValue === buttonEl.dataset.label) {
                  buttonEl.classList.add(this.CLASSES.activeFilterButton)
                }
              })
            }
          })
      }

      detectBoostUpdates () {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            for (let i = 0; i < mutation.addedNodes.length; i++) {
              if (mutation.addedNodes[i].classList !== undefined) {
                if (
                  mutation.addedNodes[i].classList.contains(
                    this.CLASSES.sortDropdown,
                  )
                ) {
                  this.updateButtonState()
                }
              }
            }
          })
        })

        observer.observe(
          document.querySelector(this.BOOST_ELEMENTS.sortByWrapper),
          { childList: true, subtree: true },
        )
      }
    },
  )
}
